export default {
    wxAppID: process.env.REACT_APP_ID,
    passport: process.env.REACT_APP_PASSPORT_DOMAIN,
    center: process.env.REACT_APP_CENTER_DOMAIN,
    centerMobileUrl: process.env.REACT_APP_CENTER_M_DOMAIN,
    topLevel: process.env.REACT_APP_COOKIE_DOMAIN,
    cashierApply: process.env.REACT_APP_CASHIER_APPLY_DOMAIN,
    chainShopApply: process.env.REACT_APP_CHAIN_SHOP_APPLY_DOMAIN,
    chainEmployeeApply: process.env.REACT_APP_CHAIN_EMPLOYEE_APPLY_DOMAIN,
}
